module.exports = __webpack_public_path__ + "img/shangye_jianghuacheng.6a69b646.png";